<!--  -->
<template>
  <el-container
    class="container"
    ref="container"
    id="container"
    v-title
    data-title="课程列表"
  >
    <linglanHeader></linglanHeader>
    <el-main>
      <div class="content" ref="content" v-html="content"></div>
    </el-main>
    <el-footer ref="footer" height="100px"
      ><div class="footer-wraper">
        <div class="footer">
          <div class="img-wraper fl">
            <img src="@/assets/images/download.jpg" alt="" />
          </div>
          <div class="info fl">
            <p>
              为了保护您的听课权益，本网站不支持与APP端、H5端同时在线，三端有且只能一端在线。如您在APP或H5端再次登录，PC端将自动退出登录。
            </p>
            <b>咨询建议请扫描二维码添加客服企业微信</b>
          </div>
          <div class="copyright fr">
            © 2017 北京灵兰精诚中医科技有限公司版权所有<br />京ICP备15057334号
            <router-link tag="a" target="_blank" :to="{ name: 'privacyPolicy' }"
              ><span style="margin-left: 15px">隐私及个人信息保护政策</span></router-link
            >
            <br />
            <router-link tag="a" target="_blank" :to="{ name: 'permit' }"
              >出版物许可</router-link
            >
          </div>
          <div class="line fr"></div>
        </div></div
    ></el-footer>
  </el-container>
</template>

<script>
import AES from "@/libs/AES.js";
import linglanHeader from "@/components/header";
import { dataUrl } from "@/config/deployUrl";
export default {
  components: {
    linglanHeader,
  },
  data() {
    return {
      conId: "",
      courseId: "",
      materialId: "",
      conType: "",
      content: "",
      articleViewRecordId: "",
      albumId: "",
      playProcess: 0,
      playProcessOver: 0,
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      windowWidth: document.documentElement.clientWidth,
      timer: null,
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.conId = AES.decrypt(this.$route.query.conId);
    console.log(this.conId);
    this.courseId = AES.decrypt(this.$route.query.courseId);
    this.materialId = AES.decrypt(this.$route.query.materialId);
    this.conType = AES.decrypt(this.$route.query.conType);
    this.albumId = AES.decrypt(this.$route.query.albumId);
    this.playProcessOver = this.$route.query.playProgress;
    this.getCourseArticleInfo4PC();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    var that = this; // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
  },
  methods: {
    windowScroll() {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let contentHeight = this.$refs.content.offsetHeight;
        if (contentHeight == this.windowHeight) {
          this.playProcess = 100;
        } else {
          this.playProcess = Math.ceil(
            Math.round(
              (parseInt(this.windowHeight + scrollTop) / parseInt(contentHeight + 200)) *
                10000
            ) / 100.0
          );
        }
        if (this.playProcessOver < 100) {
          this.playProcessOver = this.playProcess;
        }
        this.articleViewRecordForPC(3);
        this.playProgressForPC();
      }, 500);
    },
    getCourseArticleInfo4PC() {
      let token = localStorage.getItem("token");
      let reqdata = {
        token: token,
        courseId: this.courseId,
        conId: this.conId,
        materialId: this.materialId,
        conType: this.conType,
      };
      console.log(reqdata);
      this.$request.post("/api/lectures/getCourseArticleInfo4PC", reqdata).then((res) => {
        console.log(res);
        this.content = res.content;
        setTimeout(() => {
          let contentHeight = this.$refs.content.offsetHeight;
          if (contentHeight == this.windowHeight) {
            this.playProcess = 100;
          } else {
            this.playProcess = Math.ceil(
              Math.round(
                (parseInt(this.windowHeight) / parseInt(contentHeight + 200)) * 10000
              ) / 100.0
            );
          }
          if (this.playProcessOver < 100) {
            this.playProcessOver = this.playProcess;
          }
          this.playProgressForPC();
          this.articleViewRecordForPC(0);
        });
      });
    },
    playProgressForPC() {
      let _userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let _currentTime = 100;
      // let _playProcess = 100;
      let reqdata = {
        courseId: this.courseId,
        materialId: this.materialId,
        conId: this.conId,
        conType: this.conType,
        // macAddress: this.$store.state.deviceMac,
        userId: _userInfo.userId,
        alias: _userInfo.alias,
        albumId: this.albumId,
        // duration: _currentTime,
        playProcess: this.playProcessOver > 100 ? 100 : this.playProcessOver,
      };
      console.log(reqdata);
      this.$request
        .post("/api/data/playProgressForPC", reqdata, "", dataUrl)
        .then((res) => {
          console.log("数据采集总部");
          console.log(res);
        });
    },
    articleViewRecordForPC(dealType) {
      let _userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let reqdata = {
        courseId: this.courseId,
        materialId: this.materialId,
        articleId: this.conId,
        conType: this.conType,
        userId: _userInfo.userId,
        alias: _userInfo.alias,
        readFinish: 1,
        dataSource: 3,
        albumId: this.albumId,
        completion: this.playProcess > 100 ? 100 : this.playProcess,
        id: this.articleViewRecordId,
        dealType: dealType,
      };
      console.log("文字参数");
      console.log(reqdata);
      this.$request
        .post("/api/data/articleViewRecordForPC", reqdata, "", dataUrl)
        .then((res) => {
          console.log(res);
          this.articleViewRecordId = res.id;
        });
    },
  },
  beforeDestroy() {
    this.articleViewRecordForPC(3);
    this.playProgressForPC();
    window.removeEventListener("scroll", this.windowScroll);
  },
};
</script>
<style scoped>
/* @import url(); 引入css类 */
@import url("../../assets/css/common.css");
@import url("../../assets/css/main.css");
.container {
  padding-bottom: 0px !important;
}
.main {
  width: 100%;
  /* height: 340px; */
  position: relative;
}
.el-main {
  min-height: calc(100vh - 200px);
  background-color: white;
}
.el-footer {
  padding: 0px !important;
}
.el-header {
  padding: 0px;
}
.content {
  width: 1100px;
  margin: auto;
}
</style>
